import { render, staticRenderFns } from "./user_order.vue?vue&type=template&id=f70a009a&"
import script from "./user_order.vue?vue&type=script&lang=js&"
export * from "./user_order.vue?vue&type=script&lang=js&"
import style0 from "./user_order.vue?vue&type=style&index=0&id=f70a009a&prod&lang=css&"


/* normalize component */
import normalizer from "!E:\\vue_project\\nmgkjcx\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports